import globalThisPolyfill from 'globalthis';

if (typeof globalThis === 'undefined') {
  globalThisPolyfill.shim();
}
